let _ = require("lodash");

export class DeviceEventEmitter {
  static getListeners(type) {
    let l = DeviceEventEmitter.Listeners;
    if (!l[type]) {
      l[type] = [];
    }
    return l[type];
  }

  static addListener(type, action) {
    let listener = new DeviceEventEmitterListener(type, action);
    let l = DeviceEventEmitter.getListeners(type);
    l.push(listener);
    return listener;
  }

  static emit(type, arg) {
    let l = DeviceEventEmitter.getListeners(type);
    l.forEach(listener => {
      listener.exec(arg);
    });
  }
}

DeviceEventEmitter.Listeners = {};

function DeviceEventEmitterListener(type, action){
  let my = this;
  this._action = action;
  this.exec = function(arg){
    this._action(arg);
  };

  this.remove = function(){
    let l = DeviceEventEmitter.getListeners(type);
    _.remove(l, t => {
      return t === my;
    });
  };
}

export function emitBroadcast(source, arg){
  DeviceEventEmitter.emit("broadcastEvent", {source: source, ...arg}); //触发刷新UI的事件
}

export function bindBroadcast(on){
  if (on) {
    //绑定事件
    return DeviceEventEmitter.addListener("broadcastEvent", arg => {
      on(arg);
    });
  }
}
